import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { SexyModule } from '@qid/sexy';
import { PlanPurchase } from "../../models/plan-purchase.model";
import { PlanPurchaseMasterService } from "../../services/plan-purchase-master.service";

@Component({
  selector: 'org-plan-purchase-view',
  templateUrl: './org-plan-purchase-view.component.html',
  styleUrls: ['./org-plan-purchase-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    DatePipe
  ]
})
export class OrgPlanPurchaseViewComponent implements OnInit {

  @Input() orgId: string;

  planPurchases: PlanPurchase[] = []

  constructor(private planPurchaseMasterService: PlanPurchaseMasterService) {
  }

  ngOnInit() {

  }

  ngOnChanges() {
    this.fetchPlanPurchase()
  }

  async fetchPlanPurchase() {
    const query: any = {}
    if (this.orgId) {
      query.orgId = this.orgId
    }
    const res = await this.planPurchaseMasterService.readAll(1, { ...query, limit: 100 })
    this.planPurchases = res?.docs || []

  }

}
